// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Opacity Scale */
.vnsc-root {
  --vnsc-opacity-disabled: 0.38;
  --vnsc-opacity-hover: 0.04;
  --vnsc-opacity-focus: 0.12;
  --vnsc-opacity-pressed: 0.16;
  --vnsc-opacity-dragging: 0.08;
  --vnsc-opacity-overlay: 0.5;
  --vnsc-opacity-backdrop: 0.85;
  --vnsc-opacity-watermark: 0.05;
  --vnsc-opacity-skeleton-base: 0.08;
  --vnsc-opacity-skeleton-highlight: 0.15;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/opacity.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;AACzC","sourcesContent":["/* Design Tokens - Opacity Scale */\r\n.vnsc-root {\r\n  --vnsc-opacity-disabled: 0.38;\r\n  --vnsc-opacity-hover: 0.04;\r\n  --vnsc-opacity-focus: 0.12;\r\n  --vnsc-opacity-pressed: 0.16;\r\n  --vnsc-opacity-dragging: 0.08;\r\n  --vnsc-opacity-overlay: 0.5;\r\n  --vnsc-opacity-backdrop: 0.85;\r\n  --vnsc-opacity-watermark: 0.05;\r\n  --vnsc-opacity-skeleton-base: 0.08;\r\n  --vnsc-opacity-skeleton-highlight: 0.15;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
